export default [
  {
    value: 1,
    text: "2000"
  },
  {
    value: 2,
    text: "30000"
  }
]